import React from "react"
import Link from "gatsby-link"
import Helmet from "react-helmet"

import Navigation from '../layouts/navigation.js'
import Footer from '../layouts/footer.js'

import reviews_img from '../img/reviews-1.svg'
import contacts_img_1 from '../img/contacts/contacts-1.svg'

import register_now from '../img/register-now-left.svg'

import ogp_cover from '../img/cover.png'

export default class Reviews extends React.Component {

	pageClick(e) {
		document.getElementsByTagName('body')[0].className=''
	}

	fixedSidebar() {

	    var sidebar = document.getElementById('sidebar'), sidebar_scroll = document.getElementById('sidebar-scroll'), content = document.getElementById('content');
		var scrTop = window.pageYOffset,
			formOuterH = getAbsoluteHeight(sidebar_scroll),
			formH = sidebar_scroll.clientHeight,
			contentH = content.clientHeight,
			contentOfTop = getElementTop(content),
			sidebarH = sidebar.clientHeight,
			sidebarOfTop = getElementTop(sidebar),
			contentB = contentH + contentOfTop;

	    if (window.innerHeight > 767) {
			if (contentH > (sidebarH + formOuterH)) {
				sidebar_scroll.parentNode.setAttribute('style', 'min-height:'+formOuterH+'px');
				if (scrTop >= sidebarOfTop - 70) {
					sidebar_scroll.setAttribute('data-fixed', true);

					if (contentB < (scrTop + formH + 70)) {
						sidebar_scroll.setAttribute('style', 'top:'+(-((scrTop + formH) - contentB))+'px');
					} else {
						sidebar_scroll.setAttribute('style', 'top:70px');
					}

				} else {
					sidebar_scroll.setAttribute('style', 'top:auto');
					sidebar_scroll.removeAttribute('data-fixed');
				}
			}
		}

		function getElementTop(e){for(var t=e.offsetTop,a=e.offsetParent;null!=a;)t+=a.offsetTop,a=a.offsetParent;return t}

		function getAbsoluteHeight(t){t="string"==typeof t?document.querySelector(t):t;var e=window.getComputedStyle(t),o=parseFloat(e.marginTop)+parseFloat(e.marginBottom);return Math.ceil(t.offsetHeight+o)}

	}

	componentDidMount() {
	    var mask = document.getElementById('mask');
	    mask.addEventListener('touchstart', this.pageClick, false);
    	this.fixedSidebar;
		
		window.addEventListener('scroll', this.fixedSidebar, false);

		window.addEventListener('resize', this.fixedSidebar, false);
	}

	componentWillUnmount() {
		window.removeEventListener('scroll', this.fixedSidebar);
		window.removeEventListener('resize', this.fixedSidebar);
	}

	render() {
		return (
			<div>

				<Helmet
					title="UVOCorp.com - Writers' Reviews. What People Say About UvoCorp.com - UvoCorp.com"
					meta={[
						{ name: "description", content: "What writers say about writing job at UvoCorp.com. Real writers' reviews about UvoCorp.com" },

						{ property: 'og:title', content: "UVOCorp.com - Writers' Reviews. What People Say About UvoCorp.com - UvoCorp.com" },
						{ property: 'og:description', content: "What writers say about writing job at UvoCorp.com. Real writers' reviews about UvoCorp.com" },
						{ property: 'og:site_name', content: "UvoCorp.com" },
						{ property: 'og:type', content: "website" },
						{ property: 'og:image', content: ogp_cover },
					]}
					link={[
						{ rel: 'canonical', href: "https://www.uvocorp.com/reviews.html" }
					]} />

				<div className='header' id="header">
					<Navigation />
				</div>

				<div className="wrapper">

					<div className="inner-header">
						<div className="container">
							<h1>Reviews</h1>
							<Link to="/register_email.html">Register now</Link>
						</div>
					</div>

					<div className="inner-white">
						<div className="container">
							<h2 className="left">We asked our writers to share their opinion about uvocorp.com. <span className="reviews-subtitle">Check what they think about our service.</span></h2>
							<div id="content" className="col-md-8">

								<ul className="reviews">
									<li className="reviews-item">
										<div className="reviews-item-header">
											<div className="reviews-item-header-rating">
												<span className="reviews-item-header-rating-title">Writer&apos;s estimate: </span>
												<ul className="rating reviews-item-header-rating-stars">
													<li></li>
													<li></li>
													<li></li>
													<li></li>
													<li></li>
												</ul>
												<span className="reviews-item-header-rating-numbers"><strong>10</strong>/10</span>
											</div>
											<div className="reviews-item-header-writer">
												<span className="reviews-item-header-writer-id">Writer&apos;s ID #28789*</span>
												<span className="reviews-item-header-writer-registr">was registered in April 2016</span>
											</div>
										</div>
										<div className="reviews-item-text">
											<p>Working with UVOCORP is very beneficial and encouraging</p>
										</div>
									</li>
									<li className="reviews-item">
										<div className="reviews-item-header">
											<div className="reviews-item-header-rating">
												<span className="reviews-item-header-rating-title">Writer&apos;s estimate: </span>
												<ul className="rating reviews-item-header-rating-stars">
													<li></li>
													<li></li>
													<li></li>
													<li></li>
													<li></li>
												</ul>
												<span className="reviews-item-header-rating-numbers"><strong>10</strong>/10</span>
											</div>
											<div className="reviews-item-header-writer">
												<span className="reviews-item-header-writer-id">Writer&apos;s ID #23268*</span>
												<span className="reviews-item-header-writer-registr">was registered in February 2015</span>
											</div>
										</div>
										<div className="reviews-item-text">
											<p>Working with Uvocorp gives a sense of fulfillment.</p>
										</div>
									</li>

									<li className="reviews-item">
										<div className="reviews-item-header">
											<div className="reviews-item-header-rating">
												<span className="reviews-item-header-rating-title">Writer&apos;s estimate: </span>
												<ul className="rating reviews-item-header-rating-stars">
													<li></li>
													<li></li>
													<li></li>
													<li></li>
													<li></li>
												</ul>
												<span className="reviews-item-header-rating-numbers"><strong>10</strong>/10</span>
											</div>
											<div className="reviews-item-header-writer">
												<span className="reviews-item-header-writer-id">Writer&apos;s ID #2333*</span>
												<span className="reviews-item-header-writer-registr">was registered in November 2010</span>
											</div>
										</div>
										<div className="reviews-item-text">
											<p>Working with this company is fantastic. It is highly motivating.</p>
										</div>
									</li>
									<li className="reviews-item">
										<div className="reviews-item-header">
											<div className="reviews-item-header-rating">
												<span className="reviews-item-header-rating-title">Writer&apos;s estimate: </span>
												<ul className="rating reviews-item-header-rating-stars">
													<li></li>
													<li></li>
													<li></li>
													<li></li>
													<li></li>
												</ul>
												<span className="reviews-item-header-rating-numbers"><strong>10</strong>/10</span>
											</div>
											<div className="reviews-item-header-writer">
												<span className="reviews-item-header-writer-id">Writer&apos;s ID #30105*</span>
												<span className="reviews-item-header-writer-registr">was registered in March 2017</span>
											</div>
										</div>
										<div className="reviews-item-text">
											<p>Working with this company has been beneficial. I would recommend it to a friend.</p>
										</div>
									</li>

									<li className="reviews-item">
										<div className="reviews-item-header">
											<div className="reviews-item-header-rating">
												<span className="reviews-item-header-rating-title">Writer&apos;s estimate: </span>
												<ul className="rating reviews-item-header-rating-stars">
													<li></li>
													<li></li>
													<li></li>
													<li></li>
													<li></li>
												</ul>
												<span className="reviews-item-header-rating-numbers"><strong>10</strong>/10</span>
											</div>
											<div className="reviews-item-header-writer">
												<span className="reviews-item-header-writer-id">Writer&apos;s ID #352*</span>
												<span className="reviews-item-header-writer-registr">was registered in June 2009</span>
											</div>
										</div>
										<div className="reviews-item-text">
											<p>Uvocorp has proven to be very professional and I would encourage potential writers to join</p>
										</div>
									</li>
									<li className="reviews-item">
										<div className="reviews-item-header">
											<div className="reviews-item-header-rating">
												<span className="reviews-item-header-rating-title">Writer&apos;s estimate: </span>
												<ul className="rating reviews-item-header-rating-stars">
													<li></li>
													<li></li>
													<li></li>
													<li></li>
													<li></li>
												</ul>
												<span className="reviews-item-header-rating-numbers"><strong>10</strong>/10</span>
											</div>
											<div className="reviews-item-header-writer">
												<span className="reviews-item-header-writer-id">Writer&apos;s ID #28940*</span>
												<span className="reviews-item-header-writer-registr">was registered in February 2017</span>
											</div>
										</div>
										<div className="reviews-item-text">
											<p>Uvo is the best agency I have worked in. I have already recommended UVO to some of my friends. I have no negative remarks. </p>
										</div>
									</li>

									<li className="reviews-item">
										<div className="reviews-item-header">
											<div className="reviews-item-header-rating">
												<span className="reviews-item-header-rating-title">Writer&apos;s estimate: </span>
												<ul className="rating reviews-item-header-rating-stars">
													<li></li>
													<li></li>
													<li></li>
													<li></li>
													<li></li>
												</ul>
												<span className="reviews-item-header-rating-numbers"><strong>10</strong>/10</span>
											</div>
											<div className="reviews-item-header-writer">
												<span className="reviews-item-header-writer-id">Writer&apos;s ID #28689*</span>
												<span className="reviews-item-header-writer-registr">was registered in March 2016</span>
											</div>
										</div>
										<div className="reviews-item-text">
											<p>The cooperation with the company is excellent and encouraging</p>
										</div>
									</li>
									<li className="reviews-item">
										<div className="reviews-item-header">
											<div className="reviews-item-header-rating">
												<span className="reviews-item-header-rating-title">Writer&apos;s estimate: </span>
												<ul className="rating reviews-item-header-rating-stars">
													<li></li>
													<li></li>
													<li></li>
													<li></li>
													<li></li>
												</ul>
												<span className="reviews-item-header-rating-numbers"><strong>10</strong>/10</span>
											</div>
											<div className="reviews-item-header-writer">
												<span className="reviews-item-header-writer-id">Writer&apos;s ID #24366*</span>
												<span className="reviews-item-header-writer-registr">was registered in March 2015</span>
											</div>
										</div>
										<div className="reviews-item-text">
											<p>The company is a great chance have a good money for interesting and fascinating work from all parts of the world.</p>
										</div>
									</li>

									<li className="reviews-item">
										<div className="reviews-item-header">
											<div className="reviews-item-header-rating">
												<span className="reviews-item-header-rating-title">Writer&apos;s estimate: </span>
												<ul className="rating reviews-item-header-rating-stars">
													<li></li>
													<li></li>
													<li></li>
													<li></li>
													<li></li>
												</ul>
												<span className="reviews-item-header-rating-numbers"><strong>10</strong>/10</span>
											</div>
											<div className="reviews-item-header-writer">
												<span className="reviews-item-header-writer-id">Writer&apos;s ID #29529*</span>
												<span className="reviews-item-header-writer-registr">was registered in October 2016</span>
											</div>
										</div>
										<div className="reviews-item-text">
											<p>The company has been encouraging me a lot and I feel part of the team. I would not hesitate  to recommend the company to other professional writers out there to join the great team.</p>
										</div>
									</li>
									<li className="reviews-item">
										<div className="reviews-item-header">
											<div className="reviews-item-header-rating">
												<span className="reviews-item-header-rating-title">Writer&apos;s estimate: </span>
												<ul className="rating reviews-item-header-rating-stars">
													<li></li>
													<li></li>
													<li></li>
													<li></li>
													<li></li>
												</ul>
												<span className="reviews-item-header-rating-numbers"><strong>10</strong>/10</span>
											</div>
											<div className="reviews-item-header-writer">
												<span className="reviews-item-header-writer-id">Writer&apos;s ID #26934*</span>
												<span className="reviews-item-header-writer-registr">was registered in August 2015</span>
											</div>
										</div>
										<div className="reviews-item-text">
											<p>The company avail much needed cooperation which motivate the writer to deliver high quality work on orders</p>
										</div>
									</li>

									<li className="reviews-item">
										<div className="reviews-item-header">
											<div className="reviews-item-header-rating">
												<span className="reviews-item-header-rating-title">Writer&apos;s estimate: </span>
												<ul className="rating reviews-item-header-rating-stars">
													<li></li>
													<li></li>
													<li></li>
													<li></li>
													<li></li>
												</ul>
												<span className="reviews-item-header-rating-numbers"><strong>10</strong>/10</span>
											</div>
											<div className="reviews-item-header-writer">
												<span className="reviews-item-header-writer-id">Writer&apos;s ID #28119*</span>
												<span className="reviews-item-header-writer-registr">was registered in November 2015</span>
											</div>
										</div>
										<div className="reviews-item-text">
											<p>The best company to work with. </p>
										</div>
									</li>
									<li className="reviews-item">
										<div className="reviews-item-header">
											<div className="reviews-item-header-rating">
												<span className="reviews-item-header-rating-title">Writer&apos;s estimate: </span>
												<ul className="rating reviews-item-header-rating-stars">
													<li></li>
													<li></li>
													<li></li>
													<li></li>
													<li></li>
												</ul>
												<span className="reviews-item-header-rating-numbers"><strong>10</strong>/10</span>
											</div>
											<div className="reviews-item-header-writer">
												<span className="reviews-item-header-writer-id">Writer&apos;s ID #30128*</span>
												<span className="reviews-item-header-writer-registr">was registered in March 2017</span>
											</div>
										</div>
										<div className="reviews-item-text">
											<p>The benefits still outweigh few negative experiences I&apos;ve had.</p>
										</div>
									</li>

									<li className="reviews-item">
										<div className="reviews-item-header">
											<div className="reviews-item-header-rating">
												<span className="reviews-item-header-rating-title">Writer&apos;s estimate: </span>
												<ul className="rating reviews-item-header-rating-stars">
													<li></li>
													<li></li>
													<li></li>
													<li></li>
													<li></li>
												</ul>
												<span className="reviews-item-header-rating-numbers"><strong>10</strong>/10</span>
											</div>
											<div className="reviews-item-header-writer">
												<span className="reviews-item-header-writer-id">Writer&apos;s ID #27449*</span>
												<span className="reviews-item-header-writer-registr">was registered in August 2015</span>
											</div>
										</div>
										<div className="reviews-item-text">
											<p>Uvocorp is the best company for hardworking freelancers.</p>
										</div>
									</li>
									<li className="reviews-item">
										<div className="reviews-item-header">
											<div className="reviews-item-header-rating">
												<span className="reviews-item-header-rating-title">Writer&apos;s estimate: </span>
												<ul className="rating reviews-item-header-rating-stars">
													<li></li>
													<li></li>
													<li></li>
													<li></li>
													<li></li>
												</ul>
												<span className="reviews-item-header-rating-numbers"><strong>10</strong>/10</span>
											</div>
											<div className="reviews-item-header-writer">
												<span className="reviews-item-header-writer-id">Writer&apos;s ID #328*</span>
												<span className="reviews-item-header-writer-registr">was registered in April 2009</span>
											</div>
										</div>
										<div className="reviews-item-text">
											<p>My response would be that you are a company that rewards the efforts of writers without hesitation since you value their input. I would also enumerate the unrivaled advantages/benefits of working as a writer for Uvocorp.</p>
										</div>
									</li>

									<li className="reviews-item" id="28612*">
										<div className="reviews-item-header">
											<div className="reviews-item-header-rating">
												<span className="reviews-item-header-rating-title">Writer&apos;s estimate: </span>
												<ul className="rating reviews-item-header-rating-stars">
													<li></li>
													<li></li>
													<li></li>
													<li></li>
													<li></li>
												</ul>
												<span className="reviews-item-header-rating-numbers"><strong>10</strong>/10</span>
											</div>
											<div className="reviews-item-header-writer">
												<span className="reviews-item-header-writer-id">Writer&apos;s ID #28612*</span>
												<span className="reviews-item-header-writer-registr">was registered in March 2016</span>
											</div>
										</div>
										<div className="reviews-item-text">
											<p>It&apos;s very beneficial to work with you! Although more legal orders would be nice to have, in general Uvo corp is a must for both people that are beginners in remote writing! It also accommodates experienced writers very well. You are very consistent with everything written in the FAQs. Your system is easy to learn, and you should only keep doing what you were doing, but always have an ear for improvement. In short, you are professionals that take this job seriously and I hope you continue like that!</p>
										</div>
									</li>
									<li className="reviews-item">
										<div className="reviews-item-header">
											<div className="reviews-item-header-rating">
												<span className="reviews-item-header-rating-title">Writer&apos;s estimate: </span>
												<ul className="rating reviews-item-header-rating-stars">
													<li></li>
													<li></li>
													<li></li>
													<li></li>
													<li></li>
												</ul>
												<span className="reviews-item-header-rating-numbers"><strong>10</strong>/10</span>
											</div>
											<div className="reviews-item-header-writer">
												<span className="reviews-item-header-writer-id">Writer&apos;s ID #28728*</span>
												<span className="reviews-item-header-writer-registr">was registered in March 2016</span>
											</div>
										</div>
										<div className="reviews-item-text">
											<p>It is very beneficial working with the company, I would encourage my friends to join the company. You provide the best services in this industry.</p>
										</div>
									</li>

									<li className="reviews-item" id="26272*">
										<div className="reviews-item-header">
											<div className="reviews-item-header-rating">
												<span className="reviews-item-header-rating-title">Writer&apos;s estimate: </span>
												<ul className="rating reviews-item-header-rating-stars">
													<li></li>
													<li></li>
													<li></li>
													<li></li>
													<li></li>
												</ul>
												<span className="reviews-item-header-rating-numbers"><strong>10</strong>/10</span>
											</div>
											<div className="reviews-item-header-writer">
												<span className="reviews-item-header-writer-id">Writer&apos;s ID #26272*</span>
												<span className="reviews-item-header-writer-registr">was registered in August 2015</span>
											</div>
										</div>
										<div className="reviews-item-text">
											<p>It is very beneficial to work with the company. There is a constant flow of orders for the most part of the year, the payment department is fast, efficient, and supports several payment methods and the support team as well as company regulations are excellent, easy to work with, and foster professionalism. </p>
										</div>
									</li>
									<li className="reviews-item">
										<div className="reviews-item-header">
											<div className="reviews-item-header-rating">
												<span className="reviews-item-header-rating-title">Writer&apos;s estimate: </span>
												<ul className="rating reviews-item-header-rating-stars">
													<li></li>
													<li></li>
													<li></li>
													<li></li>
													<li></li>
												</ul>
												<span className="reviews-item-header-rating-numbers"><strong>10</strong>/10</span>
											</div>
											<div className="reviews-item-header-writer">
												<span className="reviews-item-header-writer-id">Writer&apos;s ID #18598*</span>
												<span className="reviews-item-header-writer-registr">was registered in January 2014</span>
											</div>
										</div>
										<div className="reviews-item-text">
											<p>It is very beneficial to work with the company. The company takes the interest of both the writers and the customers seriously. I particularly like how arising cases are handled by the departments.</p>
										</div>
									</li>

									<li className="reviews-item" id="25570*">
										<div className="reviews-item-header">
											<div className="reviews-item-header-rating">
												<span className="reviews-item-header-rating-title">Writer&apos;s estimate: </span>
												<ul className="rating reviews-item-header-rating-stars">
													<li></li>
													<li></li>
													<li></li>
													<li></li>
													<li></li>
												</ul>
												<span className="reviews-item-header-rating-numbers"><strong>10</strong>/10</span>
											</div>
											<div className="reviews-item-header-writer">
												<span className="reviews-item-header-writer-id">Writer&apos;s ID #25570*</span>
												<span className="reviews-item-header-writer-registr">was registered in August 2015</span>
											</div>
										</div>
										<div className="reviews-item-text">
											<p>It is GREAT! I love working with you, I can be ill and still not discouraged because of it, I can be at a remote location, but still have an opportunity to finish assignments, which means for me advancing of my skills and flourishing of my vocabulary! I also feel that I can help those who need assistance.</p>
										</div>
									</li>
									<li className="reviews-item">
										<div className="reviews-item-header">
											<div className="reviews-item-header-rating">
												<span className="reviews-item-header-rating-title">Writer&apos;s estimate: </span>
												<ul className="rating reviews-item-header-rating-stars">
													<li></li>
													<li></li>
													<li></li>
													<li></li>
													<li></li>
												</ul>
												<span className="reviews-item-header-rating-numbers"><strong>10</strong>/10</span>
											</div>
											<div className="reviews-item-header-writer">
												<span className="reviews-item-header-writer-id">Writer&apos;s ID #29684*</span>
												<span className="reviews-item-header-writer-registr">was registered in December 2016</span>
											</div>
										</div>
										<div className="reviews-item-text">
											<p>I&apos;ve already recommended UvoCorp to several of my friends, and even encouraged them to write to the recruiting dept. directly while the registrations were closed. So far, I&apos;ve had nothing but good experience working with UvoCorp (great pay + awesome mentor - kudos to Julia Blade + great support) - why not spread the good word?</p>
										</div>
									</li>

									<li className="reviews-item" id="12810*">
										<div className="reviews-item-header">
											<div className="reviews-item-header-rating">
												<span className="reviews-item-header-rating-title">Writer&apos;s estimate: </span>
												<ul className="rating reviews-item-header-rating-stars">
													<li></li>
													<li></li>
													<li></li>
													<li></li>
													<li></li>
												</ul>
												<span className="reviews-item-header-rating-numbers"><strong>10</strong>/10</span>
											</div>
											<div className="reviews-item-header-writer">
												<span className="reviews-item-header-writer-id">Writer&apos;s ID #12810*</span>
												<span className="reviews-item-header-writer-registr">was registered in May 2013</span>
											</div>
										</div>
										<div className="reviews-item-text">
											<p>I find UVOCORP as a highly professional site for freelance writers. I appreciate and am grateful to be part of this company in more than three years now. I&apos;m looking forward to continuously working with you and witness all improvements and progress.</p>
										</div>
									</li>
									<li className="reviews-item">
										<div className="reviews-item-header">
											<div className="reviews-item-header-rating">
												<span className="reviews-item-header-rating-title">Writer&apos;s estimate: </span>
												<ul className="rating reviews-item-header-rating-stars">
													<li></li>
													<li></li>
													<li></li>
													<li></li>
													<li></li>
												</ul>
												<span className="reviews-item-header-rating-numbers"><strong>10</strong>/10</span>
											</div>
											<div className="reviews-item-header-writer">
												<span className="reviews-item-header-writer-id">Writer&apos;s ID #22975*</span>
												<span className="reviews-item-header-writer-registr">was registered in February 2015</span>
											</div>
										</div>
										<div className="reviews-item-text">
											<p>It was a great season! Thank you for cooperation and support!</p>
										</div>
									</li>

									<li className="reviews-item">
										<div className="reviews-item-header">
											<div className="reviews-item-header-rating">
												<span className="reviews-item-header-rating-title">Writer&apos;s estimate: </span>
												<ul className="rating reviews-item-header-rating-stars">
													<li></li>
													<li></li>
													<li></li>
													<li></li>
													<li></li>
												</ul>
												<span className="reviews-item-header-rating-numbers"><strong>10</strong>/10</span>
											</div>
											<div className="reviews-item-header-writer">
												<span className="reviews-item-header-writer-id">Writer&apos;s ID #27219*</span>
												<span className="reviews-item-header-writer-registr">was registered in August 2015</span>
											</div>
										</div>
										<div className="reviews-item-text">
											<p>Taking this opportunity, I want to say a great thank you to our service. Thanks to you I found job of my dream. Thank you for your reliability, honesty and gratitude to your writers!</p>
										</div>
									</li>
									<li className="reviews-item">
										<div className="reviews-item-header">
											<div className="reviews-item-header-rating">
												<span className="reviews-item-header-rating-title">Writer&apos;s estimate: </span>
												<ul className="rating reviews-item-header-rating-stars">
													<li></li>
													<li></li>
													<li></li>
													<li></li>
													<li></li>
												</ul>
												<span className="reviews-item-header-rating-numbers"><strong>10</strong>/10</span>
											</div>
											<div className="reviews-item-header-writer">
												<span className="reviews-item-header-writer-id">Writer&apos;s ID #1184*</span>
												<span className="reviews-item-header-writer-registr">was registered in May 2010</span>
											</div>
										</div>
										<div className="reviews-item-text">
											<p>Thank you for the continued improvement. I feel more satisfied as a writer.</p>
										</div>
									</li>

									<li className="reviews-item">
										<div className="reviews-item-header">
											<div className="reviews-item-header-rating">
												<span className="reviews-item-header-rating-title">Writer&apos;s estimate: </span>
												<ul className="rating reviews-item-header-rating-stars">
													<li></li>
													<li></li>
													<li></li>
													<li></li>
													<li></li>
												</ul>
												<span className="reviews-item-header-rating-numbers"><strong>10</strong>/10</span>
											</div>
											<div className="reviews-item-header-writer">
												<span className="reviews-item-header-writer-id">Writer&apos;s ID #27415*</span>
												<span className="reviews-item-header-writer-registr">was registered in August 2015</span>
											</div>
										</div>
										<div className="reviews-item-text">
											<p>The bonus system is currently working well. The calculations are fair and they motivate towards working hard and be more precise in handling of orders to ensure ultimate customer satisfaction.</p>
										</div>
									</li>
									<li className="reviews-item">
										<div className="reviews-item-header">
											<div className="reviews-item-header-rating">
												<span className="reviews-item-header-rating-title">Writer&apos;s estimate: </span>
												<ul className="rating reviews-item-header-rating-stars">
													<li></li>
													<li></li>
													<li></li>
													<li></li>
													<li></li>
												</ul>
												<span className="reviews-item-header-rating-numbers"><strong>10</strong>/10</span>
											</div>
											<div className="reviews-item-header-writer">
												<span className="reviews-item-header-writer-id">Writer&apos;s ID #27796*</span>
												<span className="reviews-item-header-writer-registr">was registered in August 2015</span>
											</div>
										</div>
										<div className="reviews-item-text">
											<p>The bonus system is superb. In fact, it is more effective than the previous one which was more of quantitative.</p>
										</div>
									</li>

									<li className="reviews-item">
										<div className="reviews-item-header">
											<div className="reviews-item-header-rating">
												<span className="reviews-item-header-rating-title">Writer&apos;s estimate: </span>
												<ul className="rating reviews-item-header-rating-stars">
													<li></li>
													<li></li>
													<li></li>
													<li></li>
													<li></li>
												</ul>
												<span className="reviews-item-header-rating-numbers"><strong>10</strong>/10</span>
											</div>
											<div className="reviews-item-header-writer">
												<span className="reviews-item-header-writer-id">Writer&apos;s ID #28903*</span>
												<span className="reviews-item-header-writer-registr">was registered in May 2016</span>
											</div>
										</div>
										<div className="reviews-item-text">
											<p>The bonus system is understandable and clear, it gives motivation to focus on a number of aspects and thus contributes to the development not only in quantitative terms (number of pages), but in qualitative too (the content as it is).</p>
										</div>
									</li>
									<li className="reviews-item">
										<div className="reviews-item-header">
											<div className="reviews-item-header-rating">
												<span className="reviews-item-header-rating-title">Writer&apos;s estimate: </span>
												<ul className="rating reviews-item-header-rating-stars">
													<li></li>
													<li></li>
													<li></li>
													<li></li>
													<li></li>
												</ul>
												<span className="reviews-item-header-rating-numbers"><strong>10</strong>/10</span>
											</div>
											<div className="reviews-item-header-writer">
												<span className="reviews-item-header-writer-id">Writer&apos;s ID #18262*</span>
												<span className="reviews-item-header-writer-registr">was registered in December 2013</span>
											</div>
										</div>
										<div className="reviews-item-text">
											<p>The bonus system is very encouraging</p>
										</div>
									</li>

									<li className="reviews-item">
										<div className="reviews-item-header">
											<div className="reviews-item-header-rating">
												<span className="reviews-item-header-rating-title">Writer&apos;s estimate: </span>
												<ul className="rating reviews-item-header-rating-stars">
													<li></li>
													<li></li>
													<li></li>
													<li></li>
													<li></li>
												</ul>
												<span className="reviews-item-header-rating-numbers"><strong>10</strong>/10</span>
											</div>
											<div className="reviews-item-header-writer">
												<span className="reviews-item-header-writer-id">Writer&apos;s ID #18598*</span>
												<span className="reviews-item-header-writer-registr">was registered in January 2014</span>
											</div>
										</div>
										<div className="reviews-item-text">
											<p>The bonus system is very good since it looks at all the aspects of quality. It has made me work even better on my orders with an aim of getting a bonus on all criteria.</p>
										</div>
									</li>
									<li className="reviews-item">
										<div className="reviews-item-header">
											<div className="reviews-item-header-rating">
												<span className="reviews-item-header-rating-title">Writer&apos;s estimate: </span>
												<ul className="rating reviews-item-header-rating-stars">
													<li></li>
													<li></li>
													<li></li>
													<li></li>
													<li></li>
												</ul>
												<span className="reviews-item-header-rating-numbers"><strong>10</strong>/10</span>
											</div>
											<div className="reviews-item-header-writer">
												<span className="reviews-item-header-writer-id">Writer&apos;s ID #19024*</span>
												<span className="reviews-item-header-writer-registr">was registered in January 2014</span>
											</div>
										</div>
										<div className="reviews-item-text">
											<p>The new bonus system is superb. Relying on the quality of work done, the levels of performance, and general customer satisfaction as the premises of determining the bonus is way better than what was utilized prior to the paradigm shift.</p>
										</div>
									</li>
								</ul>

							</div>
							<div className="col-md-4">
								<div id="sidebar" className="sidebar">
									<div id="sidebar-scroll" className="sidebar-scroll">
										<div className="sidebar-img">
											<img src={reviews_img} alt="Reviews Image"/>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div className="inner-registration inner-registration-left">
						<div className="container">
							<div className="inner-registration-image">
								<div className="img inner-registration-img">
									<img src={register_now} alt="Start registration"/>
								</div>
							</div>
							<div className="inner-registration-text">
								<div className="inner-registration-title">Register now <br />to start earning!</div>
								<div className="inner-registration-button">
									<Link to="/register_email.html">Start registration</Link>
								</div>
							</div>
						</div>
					</div>


					<Footer />

				</div>
				<div id="mask" className="c-mask"></div>

			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/pages/reviews.html.js